<template>
</template>

<script>
import Config from 'common/script/config.js'
import Validate from 'common/script/validate.js'

	export default {
		name: 'loginCheck',
		created: function () {
			var url = window.location.href
			if (url.indexOf('u_id') > 0 && url.indexOf('token') > 0) {
				Config.cookieSet(Config.COOKIE_KEY.U_ID, Config.getReqParam('u_id'))
				Config.cookieSet(Config.COOKIE_KEY.TOKEN, Config.getReqParam('token'))
				url = Config.urlRemoveParam(['u_id', 'token'])
				window.location.href = url
			}
			this.loginCheck()
		},
		methods: {
			loginCheck: function () {
        if (Config.getReqParam('action') === 'showInfo') {
          this.thirdAppLoginCheck()
        } else {
          this.$http.post(Config.passportHost + '/login/check', {
            'u_id': Config.cookieGet(Config.COOKIE_KEY.U_ID) === undefined ? 0 : Config.cookieGet(Config.COOKIE_KEY.U_ID),
            'token': Config.cookieGet(Config.COOKIE_KEY.TOKEN) === undefined ? '' : Config.cookieGet(Config.COOKIE_KEY.TOKEN)
          }).then((response) => {
            response = response.body
            console.log(response)
            if (response.code === Config.R_CODE.INVALID_TOKEN) {
              this.$emit('nologin')
            } else if (response.code === Config.R_CODE.SUCCESS) {
              this.$emit('islogin')
            }
          })
        }
			},
      thirdAppLoginCheck: function () {
        // 第三方App显示用户信息用
        if (Config.getReqParam('action') === 'showInfo' && !Validate.stringEmpty(Config.getReqParam('token'))) {
          this.$http.post(Config.passportHost + '/public/web/thirdApp/login', {
            'token': Config.getReqParam('token')
          }).then((response) => {
            response = response.body
            if (response.code === Config.R_CODE.SUCCESS) {
              Config.cookieSet(Config.COOKIE_KEY.U_ID, response.body.id)
              Config.cookieSet(Config.COOKIE_KEY.TOKEN, response.body.token)
              Config.cookieSet(Config.COOKIE_KEY.USER_NAME, response.body.name)
              window.location.href = Config.DEFAULT_PAGE
            }
          })
        }
      }
		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus">	
</style>



// WEBPACK FOOTER //
// loginCheck.vue?7e90a096